import SideBlockAds from "@components/Blocks/Container/SideBlockAds";
import UnsubscribeForm from "@components/Blocks/NewsLetterUnsubscribeForm/NewsLetterUnsubscribeForm";
import BHBasePage, { BHBasePageProps } from "@pages/BHBasePage";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";

import styles from "./NewsletterUnsubscribe.module.css";
export function NewsletterUnsubscribePage() {
  const sectionName = "eNewsLetter";
  const newsletterPageProps: BHBasePageProps = {
    uniqueSectionName: sectionName,
    pageAdTargetValue: PageAdTargetingTypeEnum.LISTING,
  };

  return (
    <BHBasePage {...newsletterPageProps}>
      <div className="max-w-screen-xl m-auto flex flex-col lg:flex-row">
        <div className="flex lg:px-sm flex-col w-12/12 lg:w-8/12 w-full">
          <span className="text-blue-300 text-lg font-semibold">
            Berhenti Melanggan E-Newsletter
          </span>
          <div className="w-full pt-sm">
            <div className={styles.NewsletterUnsubscribeContainer}>
              <h3 className={styles.author}>
                Sila masukkan alamat e-mel anda{" "}
              </h3>
              <UnsubscribeForm />
            </div>
          </div>
        </div>
        <SideBlockAds
          pageAdTargetingProps={PageAdTargetingTypeEnum.LISTING}
          adsOnly={true}
        />
      </div>
    </BHBasePage>
  );
}
